import dayjs from 'dayjs';
import _ from 'lodash';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { twMerge } from 'tailwind-merge';
import firebaseStore from '@client/store/firebaseStore';
import notificationStore from '@client/store/notificationStore';
import Box from '@client/uikit/Box';
import Frame from '@client/uikit/Frame';
import List from '@client/uikit/List';
import { useCommonNavigate } from '@client/component/CommonLink';
import { CommonTimeFormat } from '@client/component/CommonDateFormat';

const NotificationPage = observer(() => {
    const { navigate } = useCommonNavigate();

    useEffect(() => {
        (async () => {
            const isLoggedIn = await firebaseStore.isLoggedIn();

            // 로그인되어 있지 않으면 홈으로 보냄
            if (!isLoggedIn) {
                navigate('/');
                return;
            }

            notificationStore.fetchNotifications();
        })();
    }, []);

    return (
        <Frame>
            <Frame.Title title="알림" />
            {notificationStore.isLoading && (
                <Box>
                    <div className="flex items-center justify-center py-8">
                        <span className="loading loading-ring loading-md"></span>
                    </div>
                </Box>
            )}
            {firebaseStore.isInitialized &&
                !notificationStore.isLoading &&
                _.isEmpty(notificationStore.notifications) && (
                    <Box>
                        <div className="text-base-content/60 flex items-center justify-center py-8">
                            알림이 없습니다
                        </div>
                    </Box>
                )}
            {!notificationStore.isLoading && !_.isEmpty(notificationStore.notifications) && (
                <Box>
                    <List>
                        {notificationStore.notifications.map((notification, index) => (
                            <List.Item
                                key={notification.hash}
                                className={twMerge(
                                    'cursor-pointer',
                                    notification.isClicked && 'opacity-70',
                                )}
                                onClick={async (e) => {
                                    e.preventDefault();

                                    // [순서 주의] 웹뷰가 닫힐 수도 있기 때문에 읽음 처리를 먼저 해주고 이동해야 함
                                    await notificationStore.markAsClicked(notification);

                                    // 링크가 있으면 해당 링크로 이동
                                    if (notification.data?.link) {
                                        navigate(notification.data.link);
                                    }
                                }}
                            >
                                <div className="flex flex-col gap-2">
                                    <List.ItemTitle className="indicator pr-2">
                                        {notification.title}
                                        {!notification.isClicked && (
                                            <span className="indicator-item bg-primary size-1.5 rounded-full"></span>
                                        )}
                                    </List.ItemTitle>
                                    {notification.body && (
                                        <div className="text-sm">{notification.body}</div>
                                    )}
                                    <div className="text-base-content/50 text-xs">
                                        <CommonTimeFormat
                                            time={notification.createdAt}
                                            fromNow={true}
                                        />
                                    </div>
                                </div>
                            </List.Item>
                        ))}
                    </List>
                </Box>
            )}
        </Frame>
    );
});

export default NotificationPage;
